import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import React from 'react'
import { BaseEntityNewInterface } from 'src/shared/schemas/base-entity.schema'
import createCommonEntityElement, {
  AdditionalProps,
} from 'client/pages/createCommonEntityElement'
import { WebsiteLogin } from 'src/editor/shared/entities/website-login'
import { WebsiteLoginInterface } from 'src/shared/types/entities/website-login-interface'

export const createEntityElementForWebsiteLogin = (
  entity: EntityInterface | OldEntityInterface | BaseEntityNewInterface,
  additionalProps: AdditionalProps,
) => {
  switch (entity.type) {
    case EntityTypeEnum.WebsiteLogin:
      return (
        <WebsiteLogin
          entity={entity as WebsiteLoginInterface}
          {...additionalProps}
        />
      )
    default:
      return createCommonEntityElement(
        entity as EntityInterface | OldEntityInterface,
        additionalProps,
      )
  }
}
